module.exports = __webpack_public_path__ + "img/logo.7fdd6d02.png";